import React from "react";
import {createUseStyles} from "react-jss";
import {OneOfMultiBackgrounds} from "./OneOfMultiBackgrounds";

const useStyles = createUseStyles(({ colors }) => ({
    multiBackground: {
        backgroundColor: colors.black,
        position: "sticky",
        top: 0,
        height: ({contentHeight}) => `${contentHeight}px`,
    },
}));

export const MultiBackgrounds = ({backgroundImage, currentStep, gradient, contentHeight, priority = false, isAdminMode = false}) => {
    const classes = useStyles({
        contentHeight: contentHeight
    })

    return (
        <div className={classes.multiBackground}>
            {backgroundImage?.map((background, i) => {
                const isActive = i === currentStep || (i === 0 && currentStep === null);
                return (
                    <OneOfMultiBackgrounds
                        key={i}
                        gradient={gradient}
                        background={background}
                        active={isActive}
                        opacity={isActive ? 1 : 0}
                        zIndex={100 - i}
                        priority={priority && i === 0}
                        isAdminMode={isAdminMode}
                    />
                );
            })}
        </div>
    )
}